import React, { useState } from 'react';
import { Col, Container, Row, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import DepartmentForm from '../Common/DepartmentForm';

export default function DepartmentSimple() {
  const [modalOpen, setModalOpen] = useState(false);

  // Function to toggle modal visibility
  const toggleDeptModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <Container className='p-0' fluid>
      <Row className='m-0'>
        <Col xs={12} className="p-0">
          <div className="login-card login-dark">
            <Button color="primary" onClick={toggleDeptModal}>
              Add Department
            </Button>
            <Modal isOpen={modalOpen} toggle={toggleDeptModal}>
              <ModalHeader toggle={toggleDeptModal}>Register Department</ModalHeader>
              <ModalBody>
                {/* Pass closeModal as the prop to DepartmentForm */}
                <DepartmentForm closeModal={toggleDeptModal} />
              </ModalBody>
            </Modal>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
